import Box from '@mui/material/Box';
import Shimmer from './Shimmer';

// Skeleton for the FAQ accordion list. Mirrors each collapsed row:
//   white card · rounded 16px · question bar + "+" icon on the right.
// Only the rows shimmer — hero, CTA card and WhatsApp button render
// immediately since they're static.

const FAQRowShimmer = ({ widthPct }) => (
  <Box
    sx={{
      bgcolor: '#fff',
      borderRadius: '16px',
      mb: 1.25,
      border: '1.5px solid var(--border-l)',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        px: 3.25,
        py: 2.75,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Shimmer width={`${widthPct}%`} height={14} rounded={4} />
      <Shimmer width={18} height={18} circular sx={{ ml: 1.5, flexShrink: 0 }} />
    </Box>
  </Box>
);

const FAQShimmer = ({ count = 6 }) => {
  // Vary widths so rows don't look like a uniform block.
  const widths = [82, 68, 90, 55, 78, 63, 88, 50];
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <FAQRowShimmer key={i} widthPct={widths[i % widths.length]} />
      ))}
    </>
  );
};

export default FAQShimmer;
